import videojs from 'video.js';

// utils
const urlToEl = url => {
  const DOMImg = document.createElement('img');
  DOMImg.src = url;
  return DOMImg;
};

const appendChild = parentEl => DOMElement => parentEl.appendChild(DOMElement);

const kijkwijzerUrlReducer = (allPrev, { type, imageUrl }) => {
  if (allPrev.includes(imageUrl)) {
    return allPrev;
  }
  if (type.startsWith('age')) {
    return [imageUrl, ...allPrev];
  }

  return [...allPrev, imageUrl];
};

// plugin
function kijwijzerPlugin(options) {
  const player = this;
  const kwDiv = document.createElement('div');
  kwDiv.classList.add('kijkwijzer');

  const imageUrls = options.images.reduce(kijkwijzerUrlReducer, []);
  const imageElements = imageUrls.map(urlToEl);
  const appendChildTokwDiv = appendChild(kwDiv);

  imageElements.forEach(appendChildTokwDiv);

  const videoElement = player.el();
  videoElement.appendChild(kwDiv);
}

videojs.registerPlugin('kijwijzerPlugin', kijwijzerPlugin);

export default {
  mapPropStateToOptions: ({ classifications }) => ({
    images: classifications || [],
  }),
};
